<template>
  <div id="app">
    <AppHeader />
    <router-view />
  </div>
</template>

<script setup>
import { defineOptions, onMounted } from 'vue'
import AppHeader from '@/components/AppHeader.vue'
import { initUserInfo } from '@/composables/useAuth'

defineOptions({ name: 'AppRoot' })

onMounted(() => {
  // 初始化用户信息
  initUserInfo()
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}

.el-message {
  top: 80px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  min-width: 320px;
  font-size: 16px;
}
</style>
